import classNames from 'clsx';
import React, { type FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initBizCategories, setCurrentCategory } from 'reactApp/modules/bizCategories/bizCategories.actions';
import { getBizCategoriesList, getBizCurrentCategory } from 'reactApp/modules/bizCategories/bizCategories.selectors';
import { BizCategoryType } from 'reactApp/modules/bizCategories/bizCategories.types';
import { getCurrentRouteId, getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { PageTabMenu } from 'reactApp/ui/PageTabMenu/PageTabMenu';

import styles from './BizPageTabMenu.css';

interface Props {
    noMarginBottom?: boolean;
}

const BizPageTabMenu: FC<Props> = ({ noMarginBottom }) => {
    const dispatch = useDispatch();
    const current = useSelector(getBizCurrentCategory);
    const categories = useSelector(getBizCategoriesList);
    const routeId = useSelector(getCurrentRouteId);
    const storage = useSelector(getCurrentStorage);
    const isBizUser = useSelector(UserSelectors.isBizUser);

    const handleOnTypeSelect = useCallback(
        (type: BizCategoryType) => {
            dispatch(setCurrentCategory(type));
        },
        [dispatch]
    );

    useEffect(() => {
        if (isBizUser) {
            dispatch(initBizCategories(storage));
        }
    }, [dispatch, storage, isBizUser]);

    useEffect(() => {
        if (isBizUser) {
            dispatch(setCurrentCategory(BizCategoryType.all));

            return () => {
                dispatch(setCurrentCategory(undefined));
            };
        }
    }, [dispatch, isBizUser]);

    useEffect(() => {
        if (isBizUser && storage !== EStorageType.attaches) {
            dispatch(setCurrentCategory(BizCategoryType.all));
        }
    }, [dispatch, routeId, storage, isBizUser]);

    if (!isBizUser || !current) {
        return null;
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.rootNoMarginBottom]: noMarginBottom,
            })}
            data-qa-id="bizPageTabMenu"
        >
            <PageTabMenu tabs={categories} current={current} onClick={handleOnTypeSelect} allowClickOnActive noVerticalScroll />
        </div>
    );
};

export default BizPageTabMenu;
